import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { StudentsRegisteredForOrganizationUseCaseInterface } from 'domain/usecases';

export class RemoteStudentsRegisteredForOrganization
  implements StudentsRegisteredForOrganizationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<
      StudentsRegisteredForOrganizationUseCaseInterface.Result[]
    >,
  ) {}

  async execute(
    params: StudentsRegisteredForOrganizationUseCaseInterface.Params,
  ): Promise<StudentsRegisteredForOrganizationUseCaseInterface.Result[]> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url + params.id + '/overview/last-registered-students',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
